import type * as AcceptNotification from '@ori-events/accept-notification';
import type {
  Data as ErrorData,
  AcceptNotificationResponse,
} from '@ori-events/accept-notification-failed';
import {
  isAcceptNotificationErrorResponse,
  Name as ErrorEventName,
} from '@ori-events/accept-notification-failed';

import { convertToCamelCase } from '../helpers';
import { RequestUrl } from '../models';

type Data = AcceptNotification.Data;

export default async function acceptNotificationHandler({
  detail: { reasonId },
}: CustomEvent<Data>) {
  const request = await fetch(`${RequestUrl.AcceptNotification}?reasonId=${reasonId}`);

  const response = convertToCamelCase<AcceptNotificationResponse>((await request.json()) as object);

  if (isAcceptNotificationErrorResponse(response)) {
    const errorEvent = new CustomEvent<ErrorData>(ErrorEventName, {
      detail: response,
    });
    window.dispatchEvent(errorEvent);

    return false;
  }

  return response;
}
